import moment from 'moment';

export const toStartOfDay = (date) =>
  // this function used to be: moment.utc(date).startOf('day').toJSON()
  // but there is a weird behaviour about this one.
  // In some timezones, date points always to a day before the selected one.
  // For example: select 22/11/2021, date will be 21/11/2021 on Asia/Amman timezone
  // In those cases, the format part of moment(date).format('YYYY-MM-DD') seems to fix that
  // It's weird, but works, so ¯\_ (ツ)_/¯
  (date ? `${moment(date).format('YYYY-MM-DD')}T00:00:00.000Z` : null);
